
export enum DiariseUnit
{
  Days=1,
  Weeks=2,
  Months=3,
  Year=4,
  Tomorrow=5
}